export default __webpack_public_path__ + "static/media/merchandise.861e9e80.svg";